import {
	convertBooleanToSwitch,
	convertSwitchToBoolean,
} from "common/helpers/common-utils";
import { BooleanValues } from "constants/global";
import React, { useEffect, useState } from "react";
import { ButtonGroup, Form, ToggleButton } from "react-bootstrap";

const { TRUE, FALSE } = BooleanValues;

interface Props {
	label: string;
	onChange: (value: string | undefined) => void;
	name?: string;
	value?: string;
	disabled?: boolean;
	className?: string;
}

const BftBooleanButton: React.FC<Props> = (props) => {
	const { label, onChange, name, disabled, value, className } = props;

	const [radioValue, setRadioValue] = useState<string | undefined>(
		value || undefined
	);

	useEffect(() => {
		setRadioValue(value);
	}, [value]);

	const radios = [
		{ name: "Sì", value: TRUE },
		{ name: "No", value: FALSE },
	];

	const handleChange = (e: any, type?: string) => {
		let targetValue = getTargetValue(e.currentTarget.value);
		if (type === "switch") {
			targetValue = e.target.checked ? TRUE : FALSE;
		}
		setRadioValue(targetValue);
		onChange(targetValue);
	};

	const getTargetValue = (value: string) => {
		return convertSwitchToBoolean(value);
	};

	const getSwitchValue = (value: string | undefined) => {
		return convertBooleanToSwitch(value);
	};

	return (
		<div
			className={
				"d-flex justify-content-between align-items-center container my-3 " +
				className
			}
		>
			<span className="gray ms-0">{label}</span>
			<div className="toggle-buttons">
				<ButtonGroup>
					{radios.map((radio, idx) => (
						<ToggleButton
							key={idx}
							id={`${name}-${idx}`}
							type="radio"
							variant={`boolean ${radioValue === radio.value ? "checked" : ""}`}
							name={name}
							value={radio.value}
							checked={radioValue === radio.value}
							onChange={handleChange}
							disabled={disabled}
						>
							{radio.name}
						</ToggleButton>
					))}
				</ButtonGroup>
			</div>
			<div className="switches">
				<Form.Check
					type="switch"
					id={name}
					onChange={(e) => handleChange(e, "switch")}
					value={getSwitchValue(radioValue)}
					checked={radioValue === TRUE}
				/>
			</div>
		</div>
	);
};

export default BftBooleanButton;
